import { z } from "zod";

// Form schema
export const verificationFormSchema = z
  .object({
    verifierType: z.enum(["arcade-session", "custom-verifier", "no-verifier"]),
    customVerifierUrl: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (
      data.verifierType === "custom-verifier" &&
      (!data.customVerifierUrl || data.customVerifierUrl.trim() === "")
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Custom verifier URL is required",
        path: ["customVerifierUrl"],
      });
    }
    if (
      data.verifierType === "custom-verifier" &&
      data.customVerifierUrl &&
      data.customVerifierUrl.trim() !== ""
    ) {
      try {
        new URL(data.customVerifierUrl);
      } catch {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Please enter a valid URL",
          path: ["customVerifierUrl"],
        });
      }
    }
  });

export type VerificationFormValues = z.infer<typeof verificationFormSchema>;
